import { defaultMeta } from '@/constants/defaultMeta';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { editorsPickQueries } from '@/services/editorsPick/editorsPick.queries';
import { useSearch } from '@tanstack/react-router';

export const useGetEditorsPick = (locationId: string) => {
  const search = useSearch({ from: '/(app)/recommendation-management/editors-pick/' });
  const { page, fetch, q } = search;

  const { data, isFetched, isLoading } = useQuery({
    ...editorsPickQueries.list({
      row: page ?? 0,
      fetch: fetch ?? 5,
      search: q,
      locationId,
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, search.sort),
    }),
    enabled: !!fetch,
  });

  return {
    editorsPick: data?.data || [],
    isFetched,
    isLoading,
    pagination: data?.meta?.pagination || defaultMeta,
  };
};

export default useGetEditorsPick;
